import { Routes } from '@angular/router';
import { BillsServiceService } from './services/bills-service.service';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'home',
    providers: [BillsServiceService],
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    //data: { permissions: ['admin:login'] },
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'login/:tenantCode',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'aprove-bills',
    canActivate: [AuthGuard],
    data: { permissions: ['bills:approve'] },
    loadComponent: () =>
      import('./pages/aprove-bills/aprove-bills.page').then(
        (m) => m.AproveBillsPage
      ),
  },
  {
    path: 'clients',
    canActivate: [AuthGuard],
    data: { permissions: ['clients:view'] },
    loadComponent: () =>
      import('./pages/clients/clients.page').then((m) => m.ClientsPage),
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    data: { permissions: ['reports:list'] },
    loadComponent: () =>
      import('./pages/reports/reports.page').then((m) => m.ReportsPage),
  },
  {
    path: 'client-details/:id',
    canActivate: [AuthGuard],
    data: { permissions: ['clients:update'] },
    loadComponent: () =>
      import('./pages/client-details/client-details.page').then(
        (m) => m.ClientDetailsPage
      ),
  },
  {
    path: 'report-details/:id',
    canActivate: [AuthGuard],
    data: { permissions: ['reports:view'] },
    loadComponent: () =>
      import('./pages/report-details/report-details.page').then(
        (m) => m.ReportDetailsPage
      ),
  },
  {
    path: 'send-communication',
    canActivate: [AuthGuard],
    data: { permissions: ['communications:send'], mode: 'normal' },
    loadComponent: () =>
      import('./pages/send-communication/send-communication.page').then(
        (m) => m.SendCommunicationPage
      ),
  },
  {
    path: 'comunications',
    canActivate: [AuthGuard],
    data: { permissions: ['communications:send'] },
    loadComponent: () =>
      import('./pages/comunications/comunications.page').then(
        (m) => m.ComunicationsPage
      ),
  },
  {
    path: 'contests',
    canActivate: [AuthGuard],
    data: { permissions: ['contest:view'] },
    loadComponent: () =>
      import('./pages/contests/contests.page').then((m) => m.ContestsPage),
  },
  {
    path: 'contests-details/:id',
    canActivate: [AuthGuard],
    data: { permissions: ['contest:update'] },
    loadComponent: () =>
      import('./pages/contests-details/contests-details.page').then(
        (m) => m.ContestsDetailsPage
      ),
  },
  {
    path: 'create-contest',
    canActivate: [AuthGuard],
    data: { permissions: ['contest:create'] },
    loadComponent: () =>
      import('./pages/create-contest/create-contest.page').then(
        (m) => m.CreateContestPage
      ),
  },
  {
    path: 'create-bill',
    canActivate: [AuthGuard],
    data: { permissions: ['bills:create'] },
    loadComponent: () =>
      import('./pages/create-bill/create-bill.page').then(
        (m) => m.CreateBillPage
      ),
  },
  {
    path: 'view-bills',
    canActivate: [AuthGuard],
    data: { permissions: ['bills:view'] },
    loadComponent: () =>
      import('./pages/view-bills/view-bills.page').then((m) => m.ViewBillsPage),
  },
  {
    path: 'orders',
    canActivate: [AuthGuard],
    data: { permissions: ['orders:view'] },
    loadComponent: () =>
      import('./pages/orders/orders.page').then((m) => m.OrdersPage),
  },
  {
    path: 'order-details/:id',
    canActivate: [AuthGuard],
    data: { permissions: ['orders:approve', 'orders:finish'] },
    loadComponent: () =>
      import('./pages/order-details/order-details.page').then(
        (m) => m.OrderDetailsPage
      ),
  },
  {
    path: 'preregister',
    canActivate: [AuthGuard],
    data: { permissions: ['preregister:view'] }, // TODO: change to 'preregister:view'
    loadComponent: () =>
      import('./pages/preregister/preregister.page').then(
        (m) => m.PreregisterPage
      ),
  },
  {
    path: 'groups',
    loadComponent: () =>
      import('./pages/groups/groups.page').then((m) => m.GroupsPage),
    canActivate: [AuthGuard],
    data: { permissions: ['groups:view'] }, // TODO: change to 'groups:view'
  },
  {
    path: 'upload-bill',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/upload-bill/upload-bill.page').then(
        (m) => m.UploadBillPage
      ),
  },
  {
    path: 'upload-bill/select-contest',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/upload-bill/select-contest/select-contest.page').then(
        (m) => m.SelectContestPage
      ),
  },
  {
    path: 'upload-bill/select-channel',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/upload-bill/select-channel/select-channel.page').then(
        (m) => m.SelectChannelPage
      ),
  },
  {
    path: 'upload-bill/login',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/upload-bill/login-lite/login-lite.page').then(
        (m) => m.LoginLitePage
      ),
  },
  {
    path: 'progressive-profiles',
    loadComponent: () =>
      import(
        './pages/upload-bill/progressive-profiles/progressive-profiles.page'
      ).then((m) => m.ProgressiveProfilesPage),
  },
  {
    path: 'platform-configuration',
    canActivate: [AuthGuard],
    data: { permissions: ['admin:view'] },
    loadComponent: () =>
      import('./pages/platform-configuration/platform-configuration.page').then(
        (m) => m.PlatformConfigurationPage
      ),
  },
  {
    path: 'bill-details',
    canActivate: [AuthGuard],
    data: { permissions: ['bills:approve'] },
    loadComponent: () =>
      import('./pages/bill-details/bill-details.page').then(
        (m) => m.BillDetailsPage
      ),
  },
  {
    path: 'accept-invitation/:code',
    loadComponent: () =>
      import('./pages/invitation/invitation.page').then(
        (m) => m.InvitationPage
      ),
  },
  {
    path: 'channels-config',
    loadComponent: () =>
      import(
        './pages/platform-configuration/channels-config/channels-config.page'
      ).then((m) => m.ChannelsConfigPage),
  },
  {
    path: 'general-config',
    loadComponent: () =>
      import(
        './pages/platform-configuration/general-config/general-config.page'
      ).then((m) => m.GeneralConfigPage),
  },
  {
    path: 'incremental-profile-info',
    loadComponent: () =>
      import(
        './pages/platform-configuration/incremental-profile-info/incremental-profile-info.page'
      ).then((m) => m.IncrementalProfileInfoPage),
  },
  {
    path: 'promotions',
    canActivate: [AuthGuard],
    data: { permissions: ['promotions:view'] },
    loadComponent: () =>
      import('./pages/promotions/promotions.page').then(
        (m) => m.PromotionsPage
      ),
  },
  {
    path: 'create-promotion',
    canActivate: [AuthGuard],
    data: { permissions: ['promotions:create'] },
    loadComponent: () =>
      import('./pages/promotions/create-promotion/create-promotion.page').then(
        (m) => m.CreatePromotionPage
      ),
  },
  {
    path: 'promotion-details/:id',
    canActivate: [AuthGuard],
    data: { permissions: ['promotions:update'] },
    loadComponent: () =>
      import(
        './pages/promotions/promotion-details/promotion-details.page'
      ).then((m) => m.PromotionDetailsPage),
  },
  {
    path: 'products',
    canActivate: [AuthGuard],
    data: { permissions: ['products:view'] },
    loadComponent: () =>
      import('./pages/products/products.page').then((m) => m.ProductsPage),
  },
  {
    path: 'product-details/:id',
    canActivate: [AuthGuard],
    data: { permissions: ['products:update'] },
    loadComponent: () =>
      import('./pages/products/product-details/product-details.page').then(
        (m) => m.ProductDetailsPage
      ),
  },
  {
    path: 'create-product',
    canActivate: [AuthGuard],
    data: { permissions: ['products:create'] },
    loadComponent: () =>
      import('./pages/products/create-product/create-product.page').then(
        (m) => m.CreateProductPage
      ),
  },
  {
    path: 'stores',
    loadComponent: () =>
      import('./pages/platform-configuration/stores/stores.page').then(
        (m) => m.StoresPage
      ),
  },
  {
    path: 'categories',
    loadComponent: () =>
      import('./pages/platform-configuration/categories/categories.page').then(
        (m) => m.CategoriesPage
      ),
  },
  {
    path: 'frequent-questions',
    canActivate: [AuthGuard],
    data: { permissions: ['frequent_questions:view'] },
    loadComponent: () =>
      import(
        './pages/platform-configuration/frequent-questions/frequent-questions.page'
      ).then((m) => m.FrequentQuestionsPage),
  },
  {
    path: 'events',
    canActivate: [AuthGuard],
    data: { permissions: ['events:view'] },
    loadComponent: () =>
      import('./pages/events/events.page').then((m) => m.EventsPage),
  },
  {
    path: 'create-event',
    canActivate: [AuthGuard],
    data: { permissions: ['events:create'] },
    loadComponent: () =>
      import('./pages/events/create-event/create-event.page').then(
        (m) => m.CreateEventPage
      ),
  },
  {
    path: 'event-details/:id',
    canActivate: [AuthGuard],
    data: { permissions: ['events:update'] },
    loadComponent: () =>
      import('./pages/events/event-details/event-details.page').then(
        (m) => m.EventDetailsPage
      ),
  },
  {
    path: 'pqrs',
    canActivate: [AuthGuard],
    data: { permissions: ['tickets:view'] },
    loadComponent: () =>
      import('./pages/pqrs/pqrs.page').then((m) => m.PqrsPage),
  },
  {
    path: 'pqr-details/:id',
    canActivate: [AuthGuard],
    data: { permissions: ['tickets:update'] },
    loadComponent: () =>
      import('./pages/pqrs/pqr-details/pqr-details.page').then(
        (m) => m.PqrDetailsPage
      ),
  },
  {
    path: 'create-pqr',
    canActivate: [AuthGuard],
    data: { permissions: ['tickets:create'] },
    loadComponent: () =>
      import('./pages/pqrs/create-pqr/create-pqr.page').then(
        (m) => m.CreatePqrPage
      ),
  },
  {
    path: 'transactional-messages',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import(
        './pages/platform-configuration/transactional-messages/transactional-messages.page'
      ).then((m) => m.TransactionalMessagesPage),
  },
  {
    path: 'repetitive-communications',
    canActivate: [AuthGuard],
    data: { permissions: ['communications:send'], mode: 'repetitive' },
    loadComponent: () =>
      import('./pages/send-communication/send-communication.page').then(
        (m) => m.SendCommunicationPage
      ),
  },
  {
    path: 'blacklist',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/comunications/blacklist/blacklist.page').then(
        (m) => m.BlacklistPage
      ),
  },
  {
    path: 'unsubscribe/:id',
    loadComponent: () =>
      import('./pages/unsubscribe/unsubscribe.page').then(
        (m) => m.UnsubscribePage
      ),
  },
  {
    path: 'info-points',
    loadComponent: () =>
      import(
        './pages/platform-configuration/general-config/info-points/info-points.page'
      ).then((m) => m.InfoPointsPage),
  },
  {
    path: 'generate-order',
    canActivate: [AuthGuard],
    // data: { permissions: [''] }, add permissions
    loadComponent: () =>
      import('./pages/generate-order/generate-order.page').then(
        (m) => m.GenerateOrderPage
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage
      ),
  },
  {
    path: 'page-builder',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/page-builder/page-builder.page').then(
        (m) => m.PageBuilderPage
      ),
  },
  {
    path: 'dasboard-pages-builder',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/dasboard-pages-builder/dasboard-pages-builder.page').then(
        (m) => m.DasboardPagesBuilderPage
      ),
  },
  {
    path: 'missions',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/misions/misions.page').then((m) => m.MissionsPage),
  },
  {
    path: 'mission-detail/:id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/misions/mission-detail/mission-detail.page').then(
        (m) => m.MissionDetailPage
      ),
  },
  {
    path: 'create-mission',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/misions/create-mission/create-mission.page').then(
        (m) => m.CreateMissionPage
      ),
  },
  {
    path: 'mission-review',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/mission-review/mission-review.page').then(
        (m) => m.MissionReviewPage
      ),
  },
  {
    path: 'mission-review/:id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import(
        './pages/mission-review/mission-review-detail/mission-review-detail.page'
      ).then((m) => m.MissionReviewDetailPage),
  },
  {
    path: 'goals',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/goals/goals.page').then( m => m.GoalsPage)
  },
  {
    path: 'create-goal',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/goals/create-goal/create-goal.page').then( m => m.CreateGoalPage)
  },
  {
    path: 'goal-detail/:id',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/goals/goal-detail/goal-detail.page').then( m => m.GoalDetailPage)
  },
  {
    path: 'new-repetitive-comunication',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/comunications/new-repetitive-comunication/new-repetitive-comunication.page').then( m => m.NewRepetitiveComunicationPage)
  },
  {
    path: 'new-normal-comunication',
    loadComponent: () => import('./pages/comunications/new-normal-comunication/new-normal-comunication.page').then( m => m.NewNormalComunicationPage)
  },
  {
    path: 'inventory',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/inventory/inventory.page').then( m => m.InventoryPage)
  },
  {
    path: 'mobility',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/mobility/mobility.page').then( m => m.MobilityPage)
  },
  {
    path: 'coworking',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/coworking/coworking.page').then( m => m.CoworkingPage)
  },
  {
    path: 'promotion-categories',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/platform-configuration/promotion-categories/promotion-categories.page').then( m => m.PromotionCategoriesPage)
  },
  {
    path: 'rejection-reasons',
    loadComponent: () => import('./pages/platform-configuration/rejection-reasons/rejection-reasons.page').then( m => m.RejectionReasonsPage)
  },
];
